// import React, { useState, useEffect } from "react";
// import ToDoList from "./Component/ToDoList";
// import ToDoPerformTab from "./Component/ToDoPerformTab";
// import BookingDetails from "./Component/BookingDetails";
// import DocumentTab from "./Component/DocumentTab";
// import ChatTab from "./Component/ChatTab";
// import { useParams, useSearchParams, useLocation, useNavigate } from "react-router-dom";
// import { getAllActivities, getBookingGroups, getTodoPerformance } from "../../redux/actions/todoPerformance";
// import { useDispatch, useSelector } from "react-redux";
// import Analytics from "./Component/Analytics";
// import {
//   RESET_TODO_CHAT,
//   GET_ALL_TODO_DATA,
//   GET_ALL_TODO_CUSTOM_COMPONENTS,
//   GET_ALL_TODO_PERFORMANCE,
//   GET_ALL_TODO_PERFORMANCE_GROUP,
//   SET_ASSET_TYPES,
//   SET_THREAD_COUNTER,
//   PERFORMANCE_LOADER,
// } from "../../redux/constants";
// import AssetTab from "./Component/AssetTab";
// import LinkShare from "./Component/LinkShare";
// import { socket } from "../../service/socket";

// function NewEmbeddedTodoPerformanceIndex() {
//   const [tab, setTab] = useState(1);
//   const { activity_assignment_id } = useParams();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [validation, setValidation] = useState([]);
//   const [assetentryvalue, setAssetEntryValue] = useState([{ based_on: "" }]);
//   const [activeentry, setActiveEntry] = useState([]);
//   const [performancetab, setPerformanceTab] = useState(1);
//   const [loader, setLoader] = useState(false);
//   const [searchParams] = useSearchParams();
//   const { performancedata, activities, performancegroup, tempdata, threadCounter, subGroup } =
//     useSelector((state) => state.todoPerformance);
//   const userData = useSelector((state) => state.auth);
//   const [allowbasedon, setAllowBasedon] = useState(false);
    
//   useEffect(() => {
//     if(Object.keys(userData).length === 0){
//       navigate('/auth/sign_url', { replace: true })
//     }
//   }, [navigate, userData]);
  
//   useEffect(() => {
//     setLoader(true);
//     dispatch({type: GET_ALL_TODO_DATA, payload: []})
//     dispatch(
//       getAllActivities(activity_assignment_id, (res) => {
//         setLoader(false);
//       })
//     );

//     return () => {
//       setLoader(false);
//     }
//   }, [activity_assignment_id]);

//   useEffect(() => {
//     if(location?.state?.tab === "chat"){
//       setTab(4);
//     }
//   }, []);

//   // Calculate thread counter
//   useEffect(() => {
//     if (performancedata.activity_assignment_id){
//       dispatch(getBookingGroups(performancedata.activity_assignment_id, (res) => {
//         const counter = res.data?.filter(item => item.is_read?.includes(userData?.email)) || [];
//         dispatch({type: SET_THREAD_COUNTER, payload: counter.length });
//       }))
//     }
//   }, [dispatch, performancedata.activity_assignment_id]);

//   useEffect(() => {
//     socket.on("receive_group_message", async (data) => {
//       let newMessageGroup = subGroup.find(
//         (item) => item.sub_group_id === data.success.sub_group_id
//       );
//       if(newMessageGroup && data.success.is_read?.includes(userData?.email)){  
//         const oldMessageGroup = subGroup.filter(
//           (item) => item.sub_group_id !== data.success.sub_group_id
//         );
//         const counter = [newMessageGroup, ...oldMessageGroup].filter(item => item.is_read?.includes(userData?.email)) || [];
//         dispatch({type: SET_THREAD_COUNTER, payload: counter.length });
//       }
//     })
//   }, []);

//   const handleAssetTypes = (assetStatus) => {
//     const assetypes = [];
//     tempdata.forEach((element) => {
//       const concatedAssetName = element.asset_name + "-" + element.asset_type;
//       const filteredAsset = assetStatus.find(
//         (item) => item.value === concatedAssetName
//       );
//       if (filteredAsset) {
//         element.type = filteredAsset.type;
//       }
//       assetypes.push(element);
//     });

//     dispatch({ type: SET_ASSET_TYPES, payload: assetypes });
//   };

//   useEffect(() => {
//     if (activities.length > 0 && userData.type === "collaborator") {
//       let filtered_todo_data = activities.find(
//         (element) =>
//           element.activity.todo_id === searchParams.get("activity_id")
//       );
//       if (filtered_todo_data) {

//         dispatch({ type: PERFORMANCE_LOADER, payload: true });
//         dispatch(getTodoPerformance(activity_assignment_id, filtered_todo_data?.activity.activity_id, (res) => {
//           dispatch({ type: PERFORMANCE_LOADER, payload: false });
//           if(res.status === 1){
//             filtered_todo_data = res.data[0].booking_todos[0];
//             dispatch({
//               type: GET_ALL_TODO_CUSTOM_COMPONENTS,
//               payload: filtered_todo_data.activity.activitycustomfields,
//             });
//             let files = [];
//             if (filtered_todo_data.todo_performance_groups.length > 0) {
//               if (Object.keys(performancegroup).length === 0) {
//                 dispatch({
//                   type: GET_ALL_TODO_PERFORMANCE_GROUP,
//                   payload: filtered_todo_data.todo_performance_groups[0],
//                 });
//                 dispatch({
//                   type: GET_ALL_TODO_PERFORMANCE,
//                   payload:
//                     filtered_todo_data.todo_performance_groups[0].todo_performances,
//                 });
//                 if (
//                   filtered_todo_data.activity.based_on === "Container" &&
//                   filtered_todo_data.todo_performance_groups[0].todo_performances
//                     .length > 0
//                 ) {
//                   handleAssetTypes(
//                     filtered_todo_data.todo_performance_groups[0].todo_performances
//                   );
//                 }
//                 if (
//                   filtered_todo_data.todo_performance_groups[0].todo_performances
//                     .length > 0
//                 )
//                   files =
//                     filtered_todo_data.todo_performance_groups[0]
//                       .todo_performances[0].files;
//               } else {
//                 let flag = false;
//                 filtered_todo_data.todo_performance_groups?.forEach((item, i) => {
//                   if (
//                     item.todo_performance_group_id ===
//                       performancegroup.todo_performance_group_id ||
//                     performancegroup.length === i + 1
//                   ) {
//                     flag = true;
//                     setPerformanceTab(i + 1);
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE_GROUP,
//                       payload: item,
//                     });
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE,
//                       payload: item.todo_performances,
//                     });
//                     if (
//                       filtered_todo_data.activity.based_on === "Container" &&
//                       item.todo_performances.length > 0
//                     ) {
//                       handleAssetTypes(item.todo_performances);
//                     }
//                     if (item.todo_performances.length > 0)
//                       files = item.todo_performances[0].files;
//                   }
//                 });
//                 if (!flag) {
//                   if (filtered_todo_data.todo_performance_groups.length > 0) {
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE_GROUP,
//                       payload: filtered_todo_data.todo_performance_groups[0],
//                     });
//                   } else {
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE_GROUP,
//                       payload: {},
//                     });
//                   }
//                   if (
//                     filtered_todo_data.todo_performance_groups[0].todo_performances
//                       .length > 0
//                   ) {
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE,
//                       payload:
//                         filtered_todo_data.todo_performance_groups[0]
//                           .todo_performances,
//                     });
//                   } else {
//                     dispatch({
//                       type: GET_ALL_TODO_PERFORMANCE,
//                       payload: [],
//                     });
//                   }
    
//                   if (
//                     filtered_todo_data.activity.based_on === "Container" &&
//                     filtered_todo_data.todo_performance_groups[0].todo_performances
//                       .length > 0
//                   ) {
//                     handleAssetTypes(
//                       filtered_todo_data.todo_performance_groups[0]
//                         .todo_performances
//                     );
//                   }
//                   if (
//                     filtered_todo_data.todo_performance_groups[0].todo_performances
//                       .length > 0
//                   )
//                     files =
//                       filtered_todo_data.todo_performance_groups[0]
//                         .todo_performances[0].files;
//                 }
//               }
//             }
//           }
//         }));
//       }
//     }
//   }, [activities, searchParams]);

//   return (
//     <>
//       {loader ? (
//         <div className="h-[90vh] flex justify-center items-center">
//           <div class="px-6">
//             <svg
//               className="animate-spin w-12 h-12 fill-current shrink-0"
//               viewBox="0 0 16 16"
//             >
//               <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
//             </svg>
//           </div>
//         </div>
//       ) : (
//         <div
//           className="w-screen h-screen flex bg-white p-10"
//           // style={{ height: "calc(100vh - 91px)" }}
//         >
//           {/* ------------------------------ SideBar ----------------------- */}
//           {userData.type !== "collaborator" && (
//             <div className="w-full sm:w-1/4">
//               <ToDoList
//                 setValidation={setValidation}
//                 setAssetEntryValue={setAssetEntryValue}
//                 setActiveEntry={setActiveEntry}
//                 setTab={setTab}
//                 setPerformanceTab={setPerformanceTab}
//                 setAllowBasedon={setAllowBasedon}
//               />
//             </div>
//           )}

//           <div
//             className={`w-full pl-5 pt-[3px] sm:block ${
//               userData.type !== "collaborator" && "sm:w-3/4"
//             } min-h-100`}
//           >
//             {/* ------------------------------- Tabs ------------------------- */}
//             <div className="flex items-center justify-between border-b border-b-[#D9D9D9]">
//               <div className={`sm:block`}>
//                 <ul
//                   className="w-full text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar space-x-12"
//                   id="tabs-tabJustify"
//                   role="tablist"
//                 >
//                   <li className="text-left">
//                     <a
//                       href="#tabAdded"
//                       className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
//                     ${
//                       tab === 1
//                         ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                         : ""
//                     }`}
//                       id="tab-added"
//                       data-toggle="tab"
//                       role="tablist"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         setTab(1);
//                       }}
//                     >
//                       To Do Performance
//                     </a>
//                   </li>
//                   <li className="text-left">
//                     <a
//                       href="#tabAdded"
//                       className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
//                     ${
//                       tab === 6
//                         ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                         : ""
//                     }`}
//                       id="tab-added"
//                       data-toggle="tab"
//                       role="tablist"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         setTab(6);
//                       }}
//                     >
//                       Assets
//                     </a>
//                   </li>
//                   {userData.type !== "collaborator" && (
//                     <li className="text-left">
//                       <a
//                         href="#booking_details"
//                         className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
//                       ${
//                         tab === 2
//                           ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                           : ""
//                       }`}
//                         id="booking_details"
//                         data-toggle="tab"
//                         role="tablist"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           setTab(2);
//                         }}
//                       >
//                         Booking Details
//                       </a>
//                     </li>
//                   )}

//                   {userData.type !== "customer" &&
//                     userData.type !== "collaborator" && (
//                       <li className="text-left">
//                         <a
//                           href="#documents"
//                           className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
//                       ${
//                         tab === 3
//                           ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                           : ""
//                       }`}
//                           id="documents"
//                           data-toggle="tab"
//                           role="tablist"
//                           onClick={(e) => {
//                             setTab(3);
//                           }}
//                         >
//                           Documents
//                         </a>
//                       </li>
//                     )}

//                   {/* {userData.type !== "customer" &&
//                     userData.type !== "collaborator" && ( */}
//                       <li className="relative text-left pr-4">
//                         <a
//                           href="#chat"
//                           className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold  py-2 my-3" +
//                       ${
//                         tab === 4
//                           ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                           : ""
//                       }`}
//                           id="chat"
//                           data-toggle="tab"
//                           role="tablist"
//                           onClick={(e) => {
//                             const activeTodos =
//                               performancedata.booking_todos.filter(
//                                 (item) => item.estimated_time
//                               ) || [];
//                             if (activeTodos.length > 0) {
//                               dispatch({ type: RESET_TODO_CHAT });
//                               setTab(4);
//                             }
//                           }}
//                         >
//                           Chat
//                         </a>
//                         {threadCounter > 0 && (
//                           <div className="absolute top-0 right-0">
//                             <div className="w-[15px] h-[15px] font-inter font-semibold text-[10px] rounded-full flex justify-center items-start bg-rose-500 text-white">
//                               {threadCounter}
//                             </div>
//                           </div>
//                         )}
//                       </li>
//                     {/* )} */}

//                   {/* {userData.type !== "customer" &&
//                     userData.type !== "collaborator" && (
//                       <li className="text-left">
//                         <a
//                           href="#analytics"
//                           className={` w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 my-3" +
//                       ${
//                         tab === 5
//                           ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
//                           : ""
//                       }`}
//                           id="analytics"
//                           data-toggle="tab"
//                           role="tablist"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             setTab(5);
//                           }}
//                         >
//                           Analytics
//                         </a>
//                       </li>
//                     )} */}
//                 </ul>
//               </div>
//               {!["collaborator", "customer"].includes(userData.type) && (
//                 <LinkShare activity_assignment_id={activity_assignment_id} customer_id={performancedata.customer_id} />
//               )}
//             </div>
//             {tab === 1 && (
//               <ToDoPerformTab
//                 activity_assignment_id={activity_assignment_id}
//                 validation={validation}
//                 setValidation={setValidation}
//                 assetentryvalue={assetentryvalue}
//                 setAssetEntryValue={setAssetEntryValue}
//                 activeentry={activeentry}
//                 setActiveEntry={setActiveEntry}
//                 performancetab={performancetab}
//                 setPerformanceTab={setPerformanceTab}
//                 allowbasedon={allowbasedon}
//                 setAllowBasedon={setAllowBasedon}
//                 setTab={setTab}
//               />
//             )}
//             {tab === 2 && <BookingDetails />}
//             {tab === 3 && <DocumentTab />}
//             {tab === 4 && <ChatTab />}
//             {/* {tab === 5 && <Analytics openTab={tab} />} */}
//             {tab === 6 && <AssetTab setTab={setTab} activity_assignment_id={activity_assignment_id} />}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// NewEmbeddedTodoPerformanceIndex.auth = {
//   path: "/embedded/todo/performance/:activity_assignment_id",
//   role: "ALL",
// };

// export default NewEmbeddedTodoPerformanceIndex;

import { useSelector } from "react-redux";
import PerformanceIndex from "./performanceIndex"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NewEmbeddedTodoPerformanceIndex = () => {

  const navigate = useNavigate();
  const userData = useSelector((state) => state.auth);
  const { color_palettes } = useSelector((state) => state.palettes);
  useEffect(() => {
    if(Object.keys(userData).length === 0){
      navigate('/auth/sign_url', { replace: true })
    }
  }, [navigate, userData]);

  let styleVars = {};
  
  if(color_palettes){
    styleVars = Object.keys(color_palettes).reduce((acc, shade) => {
      acc[`--bg-color-${shade}`] = color_palettes[shade];
      return acc;
    }, {});
  }

  return (
    <div
      className="w-screen h-screen bg-white"
      style={{
        ...styleVars
      }}
    > 
      <PerformanceIndex />
    </div>
  )
}


export default NewEmbeddedTodoPerformanceIndex;